module.exports = {
  familyName: 'Segoe UI',
  category: 'sans-serif',
  capHeight: 1434,
  ascent: 2210,
  descent: -514,
  lineGap: 0,
  unitsPerEm: 2048,
  xHeight: 1024,
  xWidthAvg: 906
};
